// Start each existing transport before navigation, without waiting for delivery.
// Catch synchronous failures and rejected promises outside payment error handling.
export function runAnalytics(report) {
  try { Promise.resolve(report()).catch(() => {}); } catch (_) {}
}
